import { useContext } from "react";

import { OnboardingContext } from "./OnboardingContext";

export const useOnboardingContext = () => {
  return useContext(OnboardingContext);
};
